import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useGetBrandsDataQuery, useGetBrandStatusQuery } from "../../../../services/homeAPI"
import "./style.scss";
import Loader from "../../fullPageLoader"

function Carousel() {
    const { data: brandsData, error, isLoading } = useGetBrandsDataQuery();
    const { data: brandsStatus } = useGetBrandStatusQuery();
    if (isLoading) return <Loader />;
    if (error) return <p>Failed to load data</p>;

    const images = brandsData?.brands || [];
    const slidesToShow = images.length < 5 ? images.length : 5;

    const settings = {
        dots: false,
        infinite: images.length > 1,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: images.length > 1,
        autoplaySpeed: 2000,
        arrows: false,
        draggable: images.length > 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(slidesToShow, 2),
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: Math.min(slidesToShow, 3),
                },
            },
        ],
    };

    return (
        <>
            {brandsStatus?.data?.is_active === 1 && (
                <section className="banner-clients">
                    <div className="container-fluid p-0 m-0">
                        {images.length > 0 ? (
                            <Slider {...settings}>
                                {images.map((data, index) => (
                                    <div key={index} className="client-img-div">
                                        <img src={data.image} alt={`Brand ${index}`} className="img-fluid" loading="lazy"/>
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <p>No brands available</p>
                        )}
                    </div>
                </section>
            )}
        </>

    );
}


export default Carousel;
